import type { ProductInstance } from '../shared/types';

// Wall (panel) thickness helpers, shared by every room type. (This module once
// also hosted the rectangular-room "dent" notch feature, now retired along with
// the rest of the rect-only room path — all rooms are polygonal.)

/** Default wall (panel) thickness in mm by category. */
export const DEFAULT_SAUNA_WALL = 62;
export const DEFAULT_STEAM_WALL = 90;

/** The wall thickness (mm) of an instance, falling back to the category default. */
export function wallThicknessOf(inst: Pick<ProductInstance, 'category' | 'wallThickness'>): number {
  if (typeof inst.wallThickness === 'number') return inst.wallThickness;
  return inst.category === 'steamroom' ? DEFAULT_STEAM_WALL : DEFAULT_SAUNA_WALL;
}

/** Allowed wall-thickness range (mm) by category, for the properties editor. */
export function wallThicknessRange(category: ProductInstance['category']): { min: number; max: number } {
  return category === 'steamroom' ? { min: 0, max: 200 } : { min: 50, max: 200 };
}
